import { Box } from '@material-ui/core';
import { formatDateTimeReadable, Ticketing } from '@nemuru-eng/js-api-client';

import { OverviewDetailRow } from '@/components/shared/components/OverviewDetailRow';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { PriorityTag } from '@/components/widgets/CustomerSupport/components/CustomerSupportDialog/components/CustomerSupportHeader/components/PriorityTag';
import { TicketStatusTag } from '@/components/widgets/CustomerSupport/components/CustomerSupportDialog/components/CustomerSupportHeader/components/TicketStatusTag';

interface CustomerSupportHeaderProps {
  ticketing: Ticketing;
}
export const CustomerSupportHeader = ({ ticketing }: CustomerSupportHeaderProps) => {
  return (
    <>
      <Box display={'flex'} flexDirection={'column'} pb={4}>
        <Font variant={'h4'} color={'title'} style={{ paddingBottom: '12px' }}>
          <Text strong tId={'SUMMARY'} />
        </Font>
        <OverviewDetailRow
          field={<Text tId={'CREATED_AT'} />}
          value={formatDateTimeReadable(new Date(ticketing.content.createdAt))}
        />
        <OverviewDetailRow
          field={<Text tId={'UPDATED_AT'} />}
          value={formatDateTimeReadable(new Date(ticketing.content.updatedAt))}
        />
        <OverviewDetailRow
          field={<Text tId={'TICKET_STATUS'} />}
          value={<TicketStatusTag status={ticketing.content.status} />}
        />
        {ticketing.content.priority && (
          <OverviewDetailRow
            field={<Text tId={'PRIORITY'} />}
            value={<PriorityTag priority={ticketing.content.priority} />}
          />
        )}
      </Box>
    </>
  );
};
